/**
 * Helper to determine if a project is active across the EMS system.
 * Active statuses: 1, '1', 'active', 'Active'
 * Inactive/Pending/Backlog statuses: 0, '0', 'inactive', 'Inactive', 'Backlog', 'backlog', 'canceled', etc.
 */
export const isProjectActive = (status) => {
  if (status === 1 || status === '1') return true;
  if (status === 0 || status === '0') return false;
  const s = String(status || '').trim().toLowerCase();
  if (s === 'active') return true;
  return false;
};
